module.exports = fox._r("fonts/simplifica.eot", __webpack_public_path__ + "fonts/7mXg5rJ.eot");


//////////////////
// WEBPACK FOOTER
// ./fonts/simplifica.eot
// module id = 68
// module chunks = 4